export default "__VITE_PUBLIC_ASSET__46d005d4__"